module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-container",
    on: {
      "scroll": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "scroll": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-close"
  })]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de4ac04","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 709
// module chunks = 1